import type { CatalogLoadingState, CatalogState } from "./types";

export const initialCatalogState: CatalogState = {
  bankOptions: [],
  businessTypeOptions: [],
  municipalityOptions: [],
  neighborhoodOptions: [],
  provinceOptions: [],
  sectorOptions: [],
};

export const initialLoadingState: CatalogLoadingState = {
  initial: false,
  municipalities: false,
  neighborhoods: false,
  sectors: false,
};

export const CATALOG_ERROR_MESSAGE =
  "No se pudieron cargar algunos catálogos del formulario. Intente nuevamente.";

